var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrameArrow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 6,
    viewBox: "0 0 37 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38501 2.44849H33.5002",
    stroke: "#8E93A2",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.547363 2.30874C2.6259 2.08995 4.52964 0.999065 6.55031 0.493896",
    stroke: "#8E93A2",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.82666 2.30884C1.06319 2.68729 3.06114 3.14488 3.35503 3.2628C4.94735 3.90163 6.42363 4.46547 8.08604 4.8217",
    stroke: "#8E93A2",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameArrow1);
export default __webpack_public_path__ + "static/media/frame-arrow-1.598c861887b3b6a1bf0df6449359ea9c.svg";
export { ForwardRef as ReactComponent };